// extracted by mini-css-extract-plugin
export default {"SingleProduct":"Displayproduct_SingleProduct__XbGdT"};